var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInteriorDesignAdvice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.09 39.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-interior-design-advice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.59,
    cy: 14.38,
    r: 5.53,
    fill: "#ffae00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.88,0H2.21A2.16,2.16,0,0,0,0,2.21v35.4a2.16,2.16,0,0,0,2.21,2.21H50.88a2.16,2.16,0,0,0,2.21-2.21V2.21A2.16,2.16,0,0,0,50.88,0ZM48.67,35.39H4.42v-31H48.67Z",
    fill: "#ffae00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.45,33.18S44.24,19.91,37.6,19.91s-8.84,8.85-13.27,8.85-4.42-2.21-8.85-2.21-8.84,6.63-8.84,6.63Z",
    fill: "#ffae00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInteriorDesignAdvice);
export default __webpack_public_path__ + "static/media/icon-interior-design-advice.114b9d567050c1ec9035243d55d01eb0.svg";
export { ForwardRef as ReactComponent };